<template>
  <div>
    <div class="is-expanded extended-panel travel-panel">
      <p class="panel-title">Travel Directions</p>
      <div class="panel-subtitle is-hidden-x">&nbsp;</div>

      <div class="direction-buttons">
        <div class="buttons has-addons">
          <div class="buttons has-addons is-fullwidth">
            <button class="button is-small" :class="{'is-active': method === 'driving'}"
                    @click="changeMethod('driving')">
              <img v-if="method !== 'driving'" src="@/assets/icons/driving.svg" alt="">
              <img v-if="method === 'driving'" src="@/assets/icons/driving_white.svg" alt="">
            </button>
            <button class="button is-small" :class="{'is-active': method === 'cycling'}"
                    @click="changeMethod('cycling')">
              <img src="@/assets/icons/cycling.svg" alt="" v-if="method !== 'cycling'">
              <img src="@/assets/icons/cycling_white.svg" alt="" v-if="method === 'cycling'">
            </button>
            <button class="button is-small" :class="{'is-active': method === 'walking'}"
                    @click="changeMethod('walking')">
              <img src="@/assets/icons/walking.svg" alt="" v-if="method !== 'walking'">
              <img src="@/assets/icons/walking_white.svg" alt="" v-if="method === 'walking'">
            </button>
          </div>
        </div>
      </div>

      <div class="places-search">
        <div class="flex-item" v-if="!route" :class="{'is-reverse': isSwapped}">
          <div class="left-item">
            <div class="field">
              <p class="label"><small v-if="!isSwapped">From</small><small v-if="isSwapped">To</small></p>
              <div class="control has-icons-left">
                <input class="input is-small is-disabled" type="text" value="Sandbrock Ranch" disabled>
                <span class="icon is-small is-left">
              <i class="fas fa-map-marker-alt"></i>
            </span>
              </div>
            </div>
            <div class="field">
              <p class="label"><small v-if="!isSwapped">To</small><small v-if="isSwapped">From</small></p>
              <div class="control has-icons-left">
                <input type="text" class="input is-small" v-model="destination" placeholder="address"
                       @keyup="placesSearch()">
                <span class="icon is-small is-left">
                  <i class="fas fa-map-marker-alt"></i>
                </span>
                <div class="box prediction-box" v-if="predictions && predictions.length > 0">
                  <table class="table is-fullwidth">
                    <tr v-for="prediction in predictions" @click="setDestination(prediction)">
                      <td class="is-narrow">
                        <i class="fas fa-map-marker-alt"></i>
                      </td>
                      <td>
                        <p>
                          {{ prediction.place_name }}
                        </p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="right-item swap-item">
            <a @click="swapPlace()">
              <img src="@/assets/icons/route.svg" alt="">
            </a>
          </div>
        </div>
        <a class="button is-small app-primary is-fullwidth" v-if="!route" @click="setDirection()">Go</a>
        <a class="button is-small app-primary is-fullwidth is-hidden-t" v-if="route" @click="route = null">Clear</a>
        <div class="travel-time" v-if="route">
          <div class="left">
            <p class="time">{{ getTime(route.duration) }}</p>
            <p class="distance">{{ getDistance(route.distance) }}</p>
          </div>
          <a v-if="glink" target="_blank" :href="glink">
            <i class="fas fa-link"></i>
          </a>
        </div>
        <div class="steps" v-if="route && route.legs && route.legs.length && route.legs[0].steps">
          <table class="table is-fullwidth">
            <tr v-for="steps in route.legs[0].steps">
              <td>
                <img v-if="steps['icon']" :src="require('@/assets/diving_icons/' + steps.icon)" alt="">
              </td>
              <td class="instruction">{{ steps.maneuver.instruction }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Travel from "@/mixins/Travel";
import Common from "@/mixins/Common";

export default {
  name: 'travel',
  mixins: [Travel, Common],
  data() {
    return {
      destination: null,
      isSwapped: false,
    }
  },
  computed: {
  },
  watch: {
    masterplanConfig: function (val, oldval) {
      if (val) {
        this.getOrigin();
      }
    },

    poi: function (val, oldVal) {
      if (val) {
        this.$store.commit("setActivePoi", []);
      }
    },

    route: function (val, oldVal) {
      if (val) {
        this.setIcons(val.legs[0].steps);
      }
      if (!val) {
        this.destination = null
        this.$store.commit("setActivePoi", []);
      }
    },
  },
  mounted() {
    this.listenToMutation();
  },
  methods: {
    swapPlace: function () {
      this.isSwapped = !this.isSwapped
    },

    setDirection: function () {
      if (this.destinationObject) {
        this.$store.commit("setActiveTravel", {
          coord: this.destinationObject.geometry.coordinates,
          method: this.method,
          swapped: this.isSwapped,
          marker: true
        })
      }
    },

    setDestination: function (place) {
      this.destinationObject = place;
      this.destination = this.destinationObject.place_name;
      this.predictions = null;
    },

    changeMethod: function (method) {
      this.method = method;
      this.setDirection();
    },

    placesSearch: function () {
      if (this.destination.length > 2) {
        this.fetchPlacesPrediction(this.destination);
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/amenities/Travel.vue